import React from 'react'
import { FieldValues } from 'react-hook-form'
import {
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/common/ui/form'
import { Input } from '@/common/ui/input'
import { WithdrawalLimitsFieldsProps } from '../types'

const preventMinusInput = (e: React.KeyboardEvent<HTMLInputElement>) => {
	if (e.key === '-' || e.key === 'e') {
		e.preventDefault()
	}
}

export function WithdrawalLimitsFields<
	TFieldValues extends FieldValues = FieldValues,
>({
	control,
	fieldPrefix = '',
	hideMaximum = false,
}: WithdrawalLimitsFieldsProps<TFieldValues>) {
	const getFieldName = (field: string) =>
		fieldPrefix ? `${fieldPrefix}.${field}` : field

	return (
		<div
			className={
				hideMaximum
					? 'grid grid-cols-1 gap-3 sm:gap-4'
					: 'grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4'
			}
		>
			<FormField
				control={control}
				name={getFieldName('minimumWithdrawCredit') as any}
				render={({ field }) => (
					<FormItem>
						<FormLabel className="text-sm sm:text-base">
							จำนวนการถอนขั้นต่ำ
						</FormLabel>
						<FormControl>
							<Input
								type="number"
								placeholder="กรอกจำนวนการถอนขั้นต่ำ"
								onKeyDown={preventMinusInput}
								{...field}
								value={field.value ?? ''}
								onChange={(e) =>
									field.onChange(e.target.value ? Number(e.target.value) : null)
								}
								className="text-sm sm:text-base"
							/>
						</FormControl>
						<FormMessage />
					</FormItem>
				)}
			/>

			{!hideMaximum && (
				<FormField
					control={control}
					name={getFieldName('maximumWithdrawCredit') as any}
					render={({ field }) => (
						<FormItem>
							<FormLabel className="text-sm sm:text-base">
								จำนวนการถอนสูงสุด
							</FormLabel>
							<FormControl>
								<Input
									type="number"
									onKeyDown={preventMinusInput}
									placeholder="กรอกจำนวนการถอนสูงสุด"
									{...field}
									value={field.value ?? ''}
									onChange={(e) =>
										field.onChange(
											e.target.value ? Number(e.target.value) : null,
										)
									}
									className="text-sm sm:text-base"
								/>
							</FormControl>
							<FormMessage />
						</FormItem>
					)}
				/>
			)}
		</div>
	)
}
